<template>
 <nav id="sidebar" class="px-0 sidebar">
	<ul class="nav nav-pills flex-column">
		<li class="logo-nav-item">
			<div class="d-flex justify-content-center" style="padding-top:10px">
        <img :src="mainMenu.logo" width="99" alt="logo">
      </div>
		</li>
		<li>
			<h6 class="nav-header">Modulos</h6>
		</li>
		<li class="nav-item" v-for="(item) in mainMenu.menu" :key="item.id">
			<a class="nav-link" :class="{ active: isPath(item) }" :href="item.link">
				<i class="batch-icon" :class="item.icono"></i> {{item.slug}}
			</a>
		</li>
	</ul>
</nav>
</template>

<script>

const PROJECT = process.env.VUE_APP_PROJECT;
const baseURL = process.env.VUE_APP_BASE_URL;

export default {
  name: 'SideMenu',

  props: {
    msg: String,
  },
  data() {
    return{
      
      mainMenu: {
    
        title: 'Tacos Heris',
        logo: '/img/LogoW.svg',
        menu: [
          {
            link: baseURL+'/inicio',
            slug: 'Inicio',
            icono: 'batch-icon-home',
          },
          {
            link: baseURL+'/orden',
            slug: 'Nueva Orden',
            icono: 'batch-icon-notes',
          },
          {
            link: baseURL+'/historialOrdenes',
            slug: 'Historial Ordenes',
            icono: 'batch-icon-paper-roll-ripped',
          },
          // {
          //   link: '/estadisticas',
          //   slug: 'Estadisticas',
          //   icono: 'batch-icon-tilde',
          // },
          {
            link: baseURL+'/alimentos',
            slug: 'Alimentos',
            icono: 'batch-icon-tag-alt-2',
          },
          {
            link: baseURL+'/repartidores',
            slug: 'Repartidores',
            icono: 'batch-icon-users',
          },
          {
            link: baseURL+'/configuracion',
            slug: 'Configuracion',
            icono: 'batch-icon-settings-alt-2'
          }
        ],
      } 
    }
  },
  methods:{
    isPath(item){
      //console.log('ispath', item.link, this.$route);
      return item.link == this.$route.path;
    }
  }
};
</script>

<style>
.nav-link.active{  
  background: #e52d27;  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #b31217, #e52d27);  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #b31217, #e52d27); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.sidebar{
  background: #232b2b;
}
</style>